export default __webpack_public_path__ + "static/media/matthew-dillon-cohen.b567bb44.jpg";